import { Campanium } from "./Campanium";

export class Campania {
    idCampania: string;
    plantillaId: string;
    fechaProg: string;
    horaProg: string;
    estado: string;
    envioInmediato: boolean;
    segmentos: number[];

    constructor(
        IdCampania: string,
        plantillaId: string,
        fechaProg: string,
        horaProg: string,
        estado: string,
        envioInmediato: boolean,
        segmentos: number[],
    ) {
        this.idCampania = IdCampania;
        this.plantillaId = plantillaId;
        this.fechaProg = fechaProg;
        this.horaProg = horaProg;
        this.estado = estado;
        this.envioInmediato = envioInmediato;
        this.segmentos = segmentos;
    }

    static construirPorCampanium(campania: Campanium){
        var time = campania.fechaPlanificacionEnvio.split('T')[1];
        
        return new Campania(
            campania.idNmCampania.toString(),
            campania.idNmTiponotificacion.toString(),
            campania.fechaPlanificacionEnvio.split('T')[0],
            time.split(':')[0]+':'+time.split(':')[1],
            campania.estado,
            Math.abs(new Date().getTime() - new Date(campania.fechaPlanificacionEnvio).getTime()) < 5000,
            campania.segmentos.map( (seg) => seg.idNmAudiencia)
        );
    }

    // Setter methods
    setPlantillaId(plantillaId: string): void {
        this.plantillaId = plantillaId;
    }

    setFechaProg(fechaProg: string): void {
        this.fechaProg = fechaProg;
    }

    setHoraProg(horaProg: string): void {
        this.horaProg = horaProg;
    }

    setEstado(estado: string): void {
        this.estado = estado;
    }

    setEnvioInmediato(envioInmediato: boolean): void {
        this.envioInmediato = envioInmediato;
    }

    setSegmentos(segmentos: number[]): void{
        this.segmentos = segmentos;
    }
}

export const estados = {
    "E": 0,
    "C": 1,
    "P": 2,
};
